<template>
  <div class="appBody prh-main bg-white mh-100">
    <div class="shareImg position-fixed cursor-pointer">
      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">

    </div>


    <course-top type="acthome" :shomeRate="rate" :currentItem=projectObj></course-top>
    <div class="activate-content">
      <div class="title d-flex justify-content-center align-items-center">
        <p class="mb-0 font-15 color-0d font-weight-bold">确认激活项目，进入学习</p>
      </div>
      <div class="tips bg-white px-28 py-4 font-12">
        <p class="color-33">1、项目总费用：{{projectObj.projectCost}}元</p>
        <p class="color-33">2、您已经预付费用：{{projectObj.entryCost}}元</p>
        <p class="color-33">3、您还需支付费用：<span class="font-weight-bold color-base">
          {{totalPrice}}元</span></p>
        <p class="color-33" v-if="mustCount">4、项目初始课程{{mustCount}}节课，将一并计入您的账户</p>
        <p class="color-33" v-else>4、项目暂无初始课程</p>

        <p class="color-33 mb-2" v-if="recommendCount">5、项目推荐{{recommendCount}}节课，您可以根据需要自助购课</p>
        <p class="color-33 mb-2" v-else>5、项目暂无推荐课程</p>
      </div>
      <div class="act-btn d-flex align-items-center justify-content-center pb-3">
        <van-button class="font-14" round type="info">激活项目，进入学习</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Button} from 'vant';

  Vue.use(Button);
  import CourseTop from '@/components/courseTop'

  export default {
    name: "subActivate",
    data() {
      return {
        projectObj: {},
        projectId: '',
        totalPrice: 0,
        totalCoursePrice: 0,
        mustCount: 0,
        recommendCount: 0,
        rate: 0,
        showShare: false,
        shareObj: {},
      }
    },
    components: {
      CourseTop,
    },
    mounted() {
      this.projectId = this.$route.params['id'];
      this.getProject();
    },
    methods: {

      getProject() {
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.projectObj = res;
          //添加浏览器title
          this.$store.commit('SET_BROWHEADERTITLE', {
            browserHeaderTitle: this.projectObj.name
          });
          sessionStorage.setItem("currentProject", JSON.stringify(this.projectObj));
          if (this.projectObj && this.projectObj.courseList.length > 0) {
            this.calcPrice();
          } else {
            this.totalPrice = this.projectObj.projectCost - this.projectObj.entryCost;
          }
          if (this.projectObj.statInfo) {
            if (this.projectObj.statInfo.signedUpCount && this.projectObj.statInfo.signedUpCount !== 0 && this.projectObj.statInfo.learnedCount && this.projectObj.statInfo.learnedCount !== 0) {
              this.rate = (this.projectObj.statInfo.signedUpCount / this.projectObj.statInfo.learnedCount) * 100
            } else {
              this.rate = 0;
            }
          } else {
            this.rate = 0;
          }
        })
      },
      calcPrice() {
        //计算必选课程的费用
        for (let v of this.projectObj.courseList) {
          if (v.mustSelected) {
            this.totalCoursePrice += v.usedCost;
          }
          if (v.mustSelected) {
            this.mustCount += 1;
          } else {
            this.recommendCount += 1;
          }
        }
        this.totalPrice = this.totalCoursePrice + this.projectObj.projectCost - this.projectObj.entryCost;
      },
      onShare() {
        //把生成海报需要的信息传入cookie

        this.shareObj = this.projectObj;
        this.shareObj.qrcodeUrl = window.location.href;
        this.shareObj.fromPageType = 'project';
        localStorage.setItem('share_obj', JSON.stringify(this.shareObj))
        this.$router.push('/share-poster');
      },


    }
  }
</script>

<style>
  .activate-content .title {
    height: 4.75rem;
    background: url("/static/img/pro/jihuo-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .act-btn {
    box-shadow: 0 6px 6px 0 #e3e3e35e;
  }

  .act-btn .van-button {
    padding: .75rem 2.5rem;
  }
</style>
